module.exports = __webpack_public_path__ + "static/media/casting_dionne.ee98719e.jpg";